import { fetchOneClub } from "@/apis/oneclub/base";
import type {
  GetMePayload,
  GetMeResponse,
  LoginPayload,
  LoginResponse,
} from "@/types/apis/oneclub";

export const login = (payload: LoginPayload): Promise<LoginResponse> =>
  fetchOneClub<LoginResponse>({
    url: "/members/signinforthirdparty",
    body: payload,
  });

export const getMe = (payload: GetMePayload): Promise<GetMeResponse> =>
  fetchOneClub<GetMeResponse>({
    url: "/members/getUserProfile",
    body: payload,
  });
